import { Chip } from "@ui";
import style from "./DayQuantityCell.module.scss";
import { IProxy } from "@interfaces/admin/proxy";
import { useUpdateProxyDataMutation } from "@RTKQuery/admin/proxy/proxy";
import { removeRowError } from "@global-state/pages/admin/myProxies/slice";
import { useEffect, useState } from "react";
import { useAppSelector, useAppDispatch } from "store/hooks";
import { IoClose } from "react-icons/io5";
import cn from "classnames";

export function DayQuantityCell({ day_quantity, proxy_id }: { day_quantity: IProxy["day_quantity"], proxy_id: IProxy["id"] }) {
    const [inputPaySum, setInputPaySum] = useState("");
    const [mode, setMode] = useState<"edit" | "read">("read")

    useEffect(() => {
        setInputPaySum(String(day_quantity || ""))
    }, [day_quantity])

    const [updateProxyData, { isSuccess, reset }] = useUpdateProxyDataMutation();

    const { activePaginationLimit, activePaginationPage, activeSearchIdParameter, activeSearchPhoneParameter, activeOperator, activeSelling } = useAppSelector(state => state.myProxiesAdminPage);

    const rowsIsError = useAppSelector(state => state.myProxiesAdminPage.rowsIsError)?.[proxy_id] || [];

    const dispatch = useAppDispatch();

    useEffect(() => {
        if (isSuccess) {
            dispatch(removeRowError({
                proxyId: proxy_id,
                colName: "day_quantity"
            }))
        }
    }, [isSuccess])

    return (
        <div className={style.cell}>
            {
                mode === "read"
                    ? <div
                        className="select-none cursor-pointer"
                        onClick={() => {
                            setMode("edit");
                        }}
                    >
                        <Chip
                            text={String(day_quantity || 0)}
                            color="blue"
                        />
                    </div>
                    : <input
                        type="text"
                        autoFocus
                        className={style.input}
                        value={inputPaySum}
                        onChange={(e) => setInputPaySum(e.target.value.replace(/\D/g, ""))}
                        onBlur={() => {
                            setMode("read");
                            if (inputPaySum) {
                                updateProxyData({
                                    proxy_id,
                                    params: {
                                        page: activePaginationPage,
                                        limit: activePaginationLimit,
                                        router_id: activeSearchIdParameter,
                                        operator: activeOperator,
                                        phone_number: activeSearchPhoneParameter,
                                        selling: activeSelling
                                    },
                                    body: {
                                        day_quantity: Number(inputPaySum)
                                    }
                                })
                            }
                        }}
                        onKeyDown={(e) => {
                            if (e.key === "Enter") {
                                e.preventDefault();
                                setMode("read");
                                if (inputPaySum) {
                                    updateProxyData({
                                        proxy_id,
                                        params: {
                                            page: activePaginationPage,
                                            limit: activePaginationLimit,
                                            router_id: activeSearchIdParameter,
                                            operator: activeOperator,
                                            phone_number: activeSearchPhoneParameter,
                                            selling: activeSelling
                                        },
                                        body: {
                                            day_quantity: Number(inputPaySum)
                                        }
                                    })
                                }
                            }
                        }}
                    />
            }
            <div className={cn("absolute left-full top-1/2 z-10 pl-[5px] -translate-y-1/2", rowsIsError.includes("day_quantity") ? "block" : "hidden")}>
                <Chip
                    text="Помилка"
                    color="red"
                    icon={<IoClose
                        className="w-[15px] text-[#F81F1F] h-[15px] cursor-pointer"
                        onClick={() => {
                            reset();
                            dispatch(removeRowError({
                                proxyId: proxy_id,
                                colName: "day_quantity"
                            }))
                        }}
                    />}
                    aligtIcon="right"
                />
            </div>
        </div>
    )
}